// src/pages/HomePage.jsx
import React, { lazy, Suspense, useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { SpinnerGif } from '../helpers/SpinnerGif';
import Slider from '../Slider/Slider';
import './Imagenes.css';
import { cartContext } from '../Context/CartContext';
import { authContext } from '../Context/AuthContext';
import { ButtonWebCat } from '../ButtonWebCat/ButtonWebCat';
import { BtnPromociones } from '../BtnPromociones/BtnPromociones';
import { FooterMapa } from '../FooterMapa/FooterMapa';
import OfertaBanner from '../OfertaBanner/OfertaBanner';
import Banner from '../shared/Banner/Banner';
import { bannersHome } from '../../config/config';
import { CarruselMarcas } from '../CarruselMarcas/CarruselMarcas';
import PopUp from '../shared/PopUp/PopUp';
import UltimosIngresos from './UltimosIngresos';
import Intro from '../Intro/IntroHomePage';
import TriBanner from './TriBanner';
import MarcasVenta from './MarcasVenta';
import DobleBannerCL from './DobleBannerCL';

const Highlighters = lazy(() => import('./Highlighters'));

export const HomePage = () => {
  const country = process.env.REACT_APP_COUNTRY;

  const { getCartByUser } = useContext(cartContext);
  const { token } = useContext(authContext);
  const [showPopUp, setShowPopUp] = useState(false);

  useEffect(() => {
    if (!token) return;
    getCartByUser();
  }, [])

  // Declaro funcion para controlar el rango de muetreo de popup
  const isWithinDateRange = (startDate, endDate) => {
    const currentDate = new Date();
    return currentDate >= startDate && currentDate <= endDate;
  };

      useEffect(() => {
      if (country === "UY") {
        const startDate = new Date('2025-06-05');
        const endDate = new Date('2025-08-14');
        if (isWithinDateRange(startDate, endDate)) {
          setShowPopUp(true);
        }
      } else if (country === "ARG") {
        const startDate = new Date('2025-10-27');
        const endDate = new Date('2025-11-27');
        if (isWithinDateRange(startDate, endDate)) {
          setShowPopUp(true);
        }
      } else if (country === "PY") {
        const startDate = new Date('2025-06-30');
        const endDate = new Date('2025-09-03');
        if (isWithinDateRange(startDate, endDate)) {
          setShowPopUp(true);
        }
      } else if (country === "CL") {
        const startDate = new Date('2025-08-01');
        const endDate = new Date('2025-09-30');
        if (isWithinDateRange(startDate, endDate)) {
          setShowPopUp(true);
        }
      } else if (country === "SV") {
        const startDate = new Date('2026-05-04');
        const endDate = new Date('2026-06-05');
        if (isWithinDateRange(startDate, endDate)) {
          setShowPopUp(true);
        }
      } else if (country === "HN"){
        const startDate = new Date('2026-05-04');
        const endDate = new Date('2026-06-03');
        if (isWithinDateRange(startDate, endDate)) {
          setShowPopUp(true);
        }
      }
    }, [country]);

  const handleClose = () => setShowPopUp(false);

  return (
    <div className="background">
      {(country === 'ARG' || country === 'UY' || country === 'PY' || country === 'HN' || country === 'USA' || country === 'DO') && (
        <div className="nyan-cat-run" aria-hidden="true">
          <a href="/marcas/ZEB">
            <img
              src={`${process.env.PUBLIC_URL}/imagenes/cebraconbandera.gif`}
              alt="ZEBRA"
              className="nyan-cat-run__image"
              loading="eager"
            />
          </a>
        </div>
      )}

      <PopUp
        show={showPopUp}
        handleClose={handleClose}
      />

      <Slider />

      <ButtonWebCat />

      <Suspense fallback={SpinnerGif({ text: 'CARGANDO' })}>
        <Container></Container>
      </Suspense>

      <Suspense fallback={SpinnerGif({ text: 'CARGANDO' })}>
        <BtnPromociones />
      </Suspense>

      {/* <BannerArgentinaExpo /> */}

      <Intro/>

        {country === 'ARG'
        && (
          <Suspense fallback={SpinnerGif({ text: 'CARGANDO' })}>
             <UltimosIngresos/>
          </Suspense>
        )}

      {/* Banner específico para Argentina */}
      {/* {country === "ARG" && (
        <div className="banner-argentina-expo" style={{ width: '100%', textAlign: 'center', margin: '20px 0' }}>
          <img 
            src={`${process.env.PUBLIC_URL}/imagenes/Popups/bannerExpoArgentina.jpg`}
            alt="Expo Argentina Solution Box"
            style={{ 
              width: '100%', 
              maxWidth: '1200px', 
              height: 'auto',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              cursor: 'pointer',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease'
            }}
            loading="lazy"
            onClick={() => window.open('https://expo.solutionbox.com.ar/', '_blank')}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.02)';
              e.target.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.1)';
            }}
          />
        </div>
      )} */}

      <Suspense fallback={SpinnerGif({ text: 'CARGANDO' })}>
        <OfertaBanner />
      </Suspense>


      {(country === 'CL') && <DobleBannerCL />}

      {country && bannersHome[country] && bannersHome[country].map((banner, index) => (
        <Suspense fallback={SpinnerGif({ text: 'CARGANDO' })} key={index}>
          <Banner
            src={banner.src}
            srcEn={banner.srcEn}
            alt={banner.alt}
            href={banner.href}
            email={banner.email}
          />
        </Suspense>
      ))}

      {/* <AvisaRetira /> */}

      

      {(country === 'ARG' || country === 'UY') && <TriBanner />}
      {(country === 'ARG') && <MarcasVenta/>}
      


      {(country === 'USA' || country === 'CR' || country === 'DO' || country === 'GT' || country === 'HN' || country === 'SV') && (
        <Suspense fallback={SpinnerGif({ text: 'CARGANDO' })}>
          <CarruselMarcas />
        </Suspense>
      )}

      <Suspense fallback={SpinnerGif({ text: 'CARGANDO' })}>
        <FooterMapa />
      </Suspense>
    </div>
  );
};

